export default "__VITE_ASSET__e93$0GT1__"